import React from 'react';
import PropTypes from 'prop-types';

import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import AdditionalInfoForm from 'dpl/buyer_account/components/AdditionalInfoForm';

export default function AdditionalInfoFormModal({
  onCloseClick,
  ...formProps
}) {
  return (
    <MiniOverlayModal
      className="AdditionalInfoFormModal"
      onCloseClick={onCloseClick}
    >
      <div className="pv10 ph20-md ph6">
        <AdditionalInfoForm {...formProps} />
      </div>
    </MiniOverlayModal>
  );
}

AdditionalInfoFormModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired
};
